/**
 * Students React Query Hooks
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { studentService } from '../services';

const STUDENTS_KEY = 'students';

export function useStudents(params = {}) {
  return useQuery({
    queryKey: [STUDENTS_KEY, params],
    queryFn: () => studentService.getAll(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useStudent(id) {
  return useQuery({
    queryKey: [STUDENTS_KEY, id],
    queryFn: () => studentService.getById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
  });
}

export function useCreateStudent() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: studentService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [STUDENTS_KEY] });
    },
  });
}

export function useUpdateStudent() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }) => studentService.update(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [STUDENTS_KEY] });
      queryClient.invalidateQueries({ queryKey: [STUDENTS_KEY, variables.id] });
    },
  });
}

export function useDeleteStudent() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: studentService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [STUDENTS_KEY] });
    },
  });
}

export function useStudentEnrollments(id) {
  return useQuery({
    queryKey: [STUDENTS_KEY, id, 'enrollments'],
    queryFn: () => studentService.getEnrollments(id),
    enabled: !!id,
  });
}
